import { DatesContainer } from '../../containers/filters/DatesContainer';
import { EFilterType, IFilter } from '../../types/filters';

export const dates: IFilter = {
  component: DatesContainer,
  type: EFilterType.Openable,
};
